// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3APXR","rootMobile":"styles_rootMobile__ZMngR"};